import { WASM_MRE_RELEASES_BASE_URL } from '../constants';

export const getAssetFolderPath = (version: string): string => {
  if (!version || version.trim() === '') {
    throw new Error('Version is required to construct the asset folder path.');
  }
  return `${WASM_MRE_RELEASES_BASE_URL}/${version}/assets`;
};
